/**
 * MV2-1952. Formato aceito: `usuario@dominio.extensao` — um único `@`, parte local não
 * vazia, domínio com pelo menos um ponto e extensão de 2+ letras depois do último ponto,
 * sem espaços. É a mesma regra do app (src/utils/helpers/email.ts) e do ocpp-java
 * (EmailFormatValidator): um e-mail como `nome@gmail` passava no cadastro e só falhava no
 * gateway de pagamento (PX001 - Error on getting customer ID).
 */
const EMAIL_REGEX = /^[^\s@]+@(?:[^\s@.]+\.)+[A-Za-z]{2,}$/;

/** Espaços nas pontas são removidos antes de validar e de salvar. */
export const normalizeEmail = (email?: string | null): string =>
  (email || '').trim();

export const isValidEmail = (email?: string | null): boolean =>
  EMAIL_REGEX.test(normalizeEmail(email));

/** Chave do react-translator-component para a mensagem de e-mail inválido. */
export const INVALID_EMAIL_MESSAGE =
  'Enter a valid e-mail, for example name@email.com';
